import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@environements';
import { Pagination } from '@interfaces/index';
import { catchError, map, Observable, of } from 'rxjs';
import { BACKGROUND_REQUEST } from '@interceptors/http-context';
import { DEFAULT_PAGINATION } from './types';
import { GetNotificationsParams, Notification } from './interfaces/notification.interface';

export type {
  Notification,
  NotificationSeverity,
  NotificationCategory,
  GetNotificationsParams,
} from './interfaces/notification.interface';

@Service()
export class NotificationService {
  private http = inject(HttpClient);
  private base = `${environment.SAAS_SERVICE}/notifications`;

  getAll(query: GetNotificationsParams): Observable<Pagination<Notification>> {
    let params = new HttpParams().set('page', query.page).set('perPage', query.perPage);
    if (query.category) {
      params = params.set('category', query.category);
    }
    if (query.open) {
      params = params.set('open', 'true');
    }
    return this.http
      .get<Pagination<Notification>>(this.base, { params })
      .pipe(catchError(() => of({ ...DEFAULT_PAGINATION, results: [] as Notification[] })));
  }

  getUnreadCount(): Observable<number> {
    return this.http
      .get<{ count: number }>(`${this.base}/unread-count`, {
        context: new HttpContext().set(BACKGROUND_REQUEST, true),
      })
      .pipe(map((res) => res.count));
  }

  markRead(id: string): Observable<boolean> {
    return this.http.post<void>(`${this.base}/${id}/read`, {}).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }

  markAllRead(): Observable<boolean> {
    return this.http.post<void>(`${this.base}/read-all`, {}).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
